import store from '@/stores';
import Authentication from './authentication';
import { refreshTokensOnce } from './api';

const authentication = new Authentication();

/**
 * Redux 上の期限が切れていても refresh Cookie が生きていれば復旧する。
 * WebSocket 通知や useSocketEvent の前に呼ぶ。
 */
export async function ensureSessionValidOrRefresh(): Promise<boolean> {
  const accessTokenExpiresAt = store.getState().authenticated.accessTokenExpiresAt;
  if (authentication.isSessionValid(accessTokenExpiresAt)) {
    return true;
  }
  return refreshTokensOnce({ bypassCooldown: true });
}
